import { useQuery } from "@tanstack/react-query";
import { executeQuery } from "../../../utils";
import { NumberCard, PercentageCard } from "./Cards";

export const LearnerStatsCards: React.FC = () => {
  const { isLoading, data } = useQuery<{
    activationRate: number;
    parentRate: number;
    dau: number;
    wau: number;
    mau: number;
    stickinessRatio: number;
    retentionRate: number;
    trialistCount: number;
  }>({
    queryKey: ["learnerStats"],
    queryFn: () =>
      executeQuery({ path: "/manager_new/parent-portal/learner-stats-beta" }),
    refetchOnWindowFocus: false,
  });

  if (!isLoading && !data) {
    return (
      <div className="py-10 text-center text-dm-error-500">
        <p>Unable to load learner stats</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-4 gap-4">
      <NumberCard
        title="DAU"
        value={data?.dau}
        tooltipText="Subscribers and trialists who have had an action in the past day"
      />
      <NumberCard
        title="WAU"
        value={data?.wau}
        tooltipText="Subscribers and trialists who have had an action in the past week"
      />
      <NumberCard
        title="MAU"
        value={data?.mau}
        tooltipText="Subscribers and trialists who have had an action in the past month"
      />
      <PercentageCard
        title="Stickiness Ratio"
        value={data?.stickinessRatio}
        tooltipText="Measure of how often learners use DMH on a daily basis relative to the total number of users who engage with it at least once a month"
      />
      <PercentageCard
        title="Activation Rate"
        value={data?.activationRate}
        tooltipText="Percentage of learners who have solved at least one question out of total sign-ups"
      />
      <PercentageCard
        title="Parent-Managed Accounts"
        value={data?.parentRate}
        tooltipText="Percentage of learners who have parent-managed accounts"
      />
      <PercentageCard
        title="Retention Rate"
        value={data?.retentionRate}
        tooltipText={`Percentage of users who still have "active" accounts now out of all users who had "active" accounts 30 days ago`}
      />
      <NumberCard
        title="Trialist Count"
        value={data?.trialistCount}
        tooltipText="Total number of current trialists"
      />
    </div>
  );
};
